import { createApp } from 'vue'
import App from './App.vue'

import "./scss/app.scss";
import {VueScreenSizeMixin} from "vue-screen-size";
import vClickOutside from "click-outside-vue3";

const app = createApp(App);

app.mixin(VueScreenSizeMixin);
app.use(vClickOutside);
app.mount('#app');
